/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  AddTradingChallengeUsersOptions,
  AddTradingChallengeUsersStatus200,
  AddTradingChallengeUsersStatus400,
  AddTradingChallengeUsersStatus409,
  AddTradingChallengeUsersStatus500,
} from '../types/AddTradingChallengeUsers'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { addTradingChallengeUsers } from '../clients/addTradingChallengeUsers'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const addTradingChallengeUsersMutationKey = () =>
  [{ url: '/v1/trading_challenges/add_users' }] as const

export function addTradingChallengeUsersMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = addTradingChallengeUsersMutationKey()
  return mutationOptions<
    AddTradingChallengeUsersStatus200,
    ResponseErrorConfig<
      | AddTradingChallengeUsersStatus400
      | AddTradingChallengeUsersStatus409
      | AddTradingChallengeUsersStatus500
    >,
    AddTradingChallengeUsersOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return addTradingChallengeUsers({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Add existing users to a trading challenge. For COMPETITION_MANAGER, the challenge must be assigned in managed_competition_ids. A user must have an empty ledger to join: deposits and withdrawals are barred from enrolment until the challenge is over, so that challenge credits are the only thing a participant holds and the teardown sweep cannot destroy funds of their own.
 * @summary Add users to a trading challenge
 * {@link /v1/trading_challenges/add_users}
 */
export function useAddTradingChallengeUsers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      AddTradingChallengeUsersStatus200,
      ResponseErrorConfig<
        | AddTradingChallengeUsersStatus400
        | AddTradingChallengeUsersStatus409
        | AddTradingChallengeUsersStatus500
      >,
      AddTradingChallengeUsersOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? addTradingChallengeUsersMutationKey()

  const baseOptions = addTradingChallengeUsersMutationOptions(config) as UseMutationOptions<
    AddTradingChallengeUsersStatus200,
    ResponseErrorConfig<
      | AddTradingChallengeUsersStatus400
      | AddTradingChallengeUsersStatus409
      | AddTradingChallengeUsersStatus500
    >,
    AddTradingChallengeUsersOptions,
    TContext
  >

  return useMutation<
    AddTradingChallengeUsersStatus200,
    ResponseErrorConfig<
      | AddTradingChallengeUsersStatus400
      | AddTradingChallengeUsersStatus409
      | AddTradingChallengeUsersStatus500
    >,
    AddTradingChallengeUsersOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    AddTradingChallengeUsersStatus200,
    ResponseErrorConfig<
      | AddTradingChallengeUsersStatus400
      | AddTradingChallengeUsersStatus409
      | AddTradingChallengeUsersStatus500
    >,
    AddTradingChallengeUsersOptions,
    TContext
  >
}
